import React, { useCallback, useEffect, useRef, useState } from 'react';
import { Pressable, StyleSheet } from 'react-native';
import { Box, VStack, Stack, Heading, Button, Text, View, HStack } from 'native-base';
import Job from './Job';
import TimeClock from './TimeClock';
import { v4 as uuidv4 } from 'uuid';
import { createIconSetFromFontello } from 'react-native-vector-icons';
import lineAwesomeConfig from '../../../Assets/Fontello/line-awesome-config.json';
import main from '../../../Assets/Styles/main.json';
import Trans from '../../Components/Trans';

const mainStyle = StyleSheet.create(main);
const Icon = createIconSetFromFontello(lineAwesomeConfig);

const ShiftList = (props) => {

    const
        firstLoad = useRef(true),
        [departmentShifts, setDepartmentShifts] = useState([]),
        [shown, setShown] = useState(typeof props.show !== 'undefined' ? props.show : true),
        [collapseTitleId, setCollapseTitleId] = useState(uuidv4())
        ;

    const onFirstLoad = useCallback(() => {
        const init = async () => {

            let newDepartmentShifts = [];
            for (let shift of props.employeeShifts) {

                let disabled = false;
                let startOn = new Date(shift.shift.startOn);
                let limit = new Date();
                limit.setHours(limit.getHours() + 2);

                if (startOn > limit) {
                    disabled = true;
                }

                newDepartmentShifts.push(
                    <Stack
                        direction={{
                            md: 'row',
                            base: 'column'
                        }}
                    >
                        <Box flexGrow={1} flexShrink={1}>
                            <Job disabled={disabled} key={uuidv4()} job={shift} />
                        </Box>
                        <TimeClock disabled={disabled} job={shift} onReload={() => {
                            props.callback();
                        }} />
                    </Stack>
                );
            }

            setDepartmentShifts(newDepartmentShifts);

        };
        init();
    }, [setDepartmentShifts, props]);

    useEffect(() => {
        if (firstLoad.current) {
            firstLoad.current = false;
            onFirstLoad();
        }
    }, [onFirstLoad]);

    return (
        <VStack
            style={[mainStyle.whiteBox,]}
            space={2}>
            <Pressable
                onPress={() => {
                    setShown(!shown);
                    setCollapseTitleId(uuidv4());
                }}
                style={mainStyle.clockDivisionTitle}
            >
                <HStack space={1} alignItems={'center'}>
                    <Icon name={shown ? 'angle-down' : 'angle-right'} />
                    <Heading style={mainStyle.pageTitle}>{props.name}</Heading>
                </HStack>
                <View>
                    <Button
                        variant={'subtle'}
                        onPress={() => {
                            setShown(!shown);
                            setCollapseTitleId(uuidv4());
                        }}>
                        <Text color={'primary.600'} key={collapseTitleId}>
                            <Trans>{shown ? 'Collapse' : 'Uncollapse'}</Trans>
                        </Text>
                    </Button>
                </View>
            </Pressable>
            {shown &&
                <VStack space={0}>
                    {departmentShifts}
                </VStack>
            }
        </VStack>
    );
};

export default ShiftList;